import { useEffect, useState } from "react";
import { _adr } from "../address";
import { CheckToken } from "./services";
import { Route, Navigate } from "react-router-dom";
import { Spin } from "antd";
import { useSelector } from "react-redux";
export const ProtectedRoute = ({ element: Component, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });
  useEffect(() => {
    CheckToken()
      .then((validToken) => {
        if (validToken && rest?.role) {
          if (rest?.role === "global" || _currentUser.roles.includes(rest?.role)) {
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
          }
        } else {
          setIsAuthenticated(validToken);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" style={{ margin: "auto" }} />
        </div>
      </>
    );
  }

  return isAuthenticated ? <Component /> : <Navigate to={_adr.Root + _adr.Login.Index} replace state={{ from: rest.path }} />;
};

export const ProtectedRouteLogin = ({ element: Component, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    CheckToken()
      .then((validToken) => {
        setIsAuthenticated(validToken);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1",
            justifyItems: "center",
            height: "100vh",
          }}
        >
          <Spin size="large" style={{ margin: "auto" }} />
        </div>
      </>
    );
  }

  return isAuthenticated ? <Navigate to={_adr.Root + _adr.Home} replace state={{ from: rest.path }} /> : <Component />;
};
